var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"border":"0"},attrs:{"name":"report","height":"100%","width":"100%","src":"//wbcp.office4u.xyz/download"}})}
var staticRenderFns = []

export { render, staticRenderFns }